module.exports = __webpack_public_path__ + "img/top_overview.3dfa92dd.jpg";